/**
 * Reducer + initial-state builder for the AIChatAgentConfig slice.
 *
 * Defaults: systemPrompt '', model GEMINI_2_5_PRO, temperature 0.2, maxTokens 2048,
 * enableExternalSearch false.
 */
import { ModelNameEnum } from '../../models/ModelNameEnum';
import type { AgentConfigAction, AgentConfigState } from './aiChatAgentConfigTypes';

export const AGENT_CONFIG_ACTIONS = {
  SET_SYSTEM_PROMPT: 'SET_SYSTEM_PROMPT',
  SET_MODEL: 'SET_MODEL',
  SET_TEMPERATURE: 'SET_TEMPERATURE',
  SET_MAX_TOKENS: 'SET_MAX_TOKENS',
  SET_ENABLE_EXTERNAL_SEARCH: 'SET_ENABLE_EXTERNAL_SEARCH',
} as const;

/**
 * Build the initial AgentConfig state, applying any provided overrides on top of the
 * documented defaults. Overrides come from the AgentConfig slice of AIChatProvider's
 * own initialState prop (initial-state seeding).
 */
export function getInitialAgentConfigState(overrides: Partial<AgentConfigState> = {}): AgentConfigState {
  return {
    systemPrompt: '',
    model: ModelNameEnum.GEMINI_2_5_PRO,
    temperature: 0.2,
    maxTokens: 2048,
    enableExternalSearch: false,
    ...overrides,
  };
}

export function agentConfigReducer(state: AgentConfigState, action: AgentConfigAction): AgentConfigState {
  switch (action.type) {
    case AGENT_CONFIG_ACTIONS.SET_SYSTEM_PROMPT:
      return { ...state, systemPrompt: action.payload };
    case AGENT_CONFIG_ACTIONS.SET_MODEL:
      return { ...state, model: action.payload };
    case AGENT_CONFIG_ACTIONS.SET_TEMPERATURE:
      return { ...state, temperature: action.payload };
    case AGENT_CONFIG_ACTIONS.SET_MAX_TOKENS:
      return { ...state, maxTokens: action.payload };
    case AGENT_CONFIG_ACTIONS.SET_ENABLE_EXTERNAL_SEARCH:
      return { ...state, enableExternalSearch: action.payload };
    default:
      return state;
  }
}
